export function PhoneNumber(props) {
    var digitsOnly = ('' + props.phoneNumber).replace(/\D/g, '')
    var match = digitsOnly.match(/^(\d{3})(\d{3})(\d{4})$/)
    return (!match) ? props.phoneNumber : '(' + match[1] + ') ' + match[2] + '-' + match[3]
}
